import * as Sentry from '@sentry/react-router'
import { startTransition, StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

import { SENTRY_DSN } from '~/config/env'
import { setupCsrfInterceptor } from '~/utils/csrf.client'
import { SENTRY_DEFAULT_OPTIONS } from '~/utils/sentry'

setupCsrfInterceptor()

Sentry.init({
  ...SENTRY_DEFAULT_OPTIONS,
  dsn: SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 0.005, // we have low-cost plan
})

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  )
})
